import {icons as importedIcons} from '@/assets/icons/assets_icons.js';

export default {
  install(Vue) {
    Vue.prototype.$icons = importedIcons;
  }
}
